module.exports = __webpack_public_path__ + "assets/PatternLeft.1fb7ef485af6bf0f014d503c34778625.png";